import api from '../api';
let apiUrl = 'transactions';

const state = {
    data: {},
    meta: {},
    current: null
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    show: async ({ commit }, id) => {
        return await api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    store: async ({ commit }, data) => {
        return await api
            .post(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    delete: async ({ commit }, data) => {
        return await api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    },
    setLanguage(state, data) {
        state.current = data;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getActiveLanguage: (state) => {
        return state.data.find((item) => item.iso_3166_2 === current);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
